/**
 * 设置缓存信息
 * @param key
 * @param data
 */
export function setSessionStorage (key, data) {
  return window.sessionStorage.setItem(key, JSON.stringify(data))
}

/**
* 获取指定缓存信息
* @param key
*/
export function getSessionStorage (key) {
  if (window.sessionStorage.getItem(key) === 'undefined') {
    return undefined
  } else {
    return JSON.parse(window.sessionStorage.getItem(key))
  }
}

/**
* 删除指定缓存
* @param key
*/
export function removeSessionStorage (key) {
  return window.sessionStorage.removeItem(key)
}
